@if (item) {
<href [link]="item.image_link">

    <div class="ratio-1-1 flex flex-justify-center flex-middle"
         (mouseenter)="onMouseIn()"
         (mouseleave)="onMouseOut()">
        <!-- image -->
        <img class="rf"
             [image]="item.image" />
        <!-- sale pill -->
        @if (item.pill_copy) {
        <sale-pill class="pos-absolute z-2"
                   [ngClass]="smallPill ? 'top-1-s right-1-s' : 'top-4 right-4'"
                   [copy]="item.pill_copy"
                   [textColor]="item.pill_text_color"
                   [bgColor]="item.pill_bg_color"
                   [small]="smallPill"></sale-pill>
        }
        <!-- title -->
        <div class="fill center col-w z-1 square-content">
            <div class="pos-absolute top-50 left-0 w-12">
                <span class="square-title"
                      sizeClass="XL:h2, SM: h4"
                      *iCms="'title' of item"
                      [ngStyle]="{'color': item.font_color || 'black'}">
                </span>
                <ng-container *ifSize="'XL'">
                    @if (item.hover_copy || item?.hover_cta?.length > 0) {
                    <p class="hover-copy"
                       [ngClass]="{'show': mouseIn}">
                        <span [ngClass]="componentVariant === 'squares_row' ? 'w-10' : 'w-6'"
                              class="p1 p-t inline-block"
                              *iCms="'hover_copy' of item; skipEmpty: true"
                              [ngStyle]="{'color': item.font_color || 'black'}"></span>
                        @if (item?.hover_cta?.length > 0) {
                        @for (cta of item.hover_cta; track cta) {
                        <!-- button -->
                        <href [link]="cta.hover_cta_link">
                            <button type="button"
                                    class="w-12 m-t-3 p-b-1">
                                <span class="b-b p-b-1 p1"
                                      *iCms="'hover_cta_copy' of cta"
                                      [ngStyle]="{'color': item.font_color || 'black','border-color': item.font_color || 'black'}">
                                </span>
                            </button>
                        </href>
                        }
                        }
                    </p>
                    }
                </ng-container>
            </div>
        </div>
    </div>
</href>
}

@if (item?.cta_copy) {
<!-- button -->
<href class="p-a-5 left pos-absolute range-button z-1"
      [link]="item.cta_link">
    <span class="b-b p-b-1 p1 z-1"
          *iCms="'cta_copy' of item"
          [ngStyle]="{'color': item.font_color || 'black','border-color': item.font_color || 'black'}">
    </span>
</href>
}
